function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.19,15.51a9.68,9.68,0,0,1-5.44,5.75v4.48a3.75,3.75,0,0,1-7.5,0V21.26a9.75,9.75,0,0,1,7-18.19,9.74,9.74,0,0,1,5.94,12.44Zm-7.08,11H13.89a2.23,2.23,0,0,0,4.22,0Zm.14-3h-4.5V25h4.5ZM23.44,8.7a8.13,8.13,0,0,0-4.69-4.22A8.22,8.22,0,0,0,16,4a8.37,8.37,0,0,0-3.55.81A8.26,8.26,0,0,0,13.25,20a.74.74,0,0,1,.5.7V22h1.5V17.05l-2-2L14.33,14,16,15.69,17.78,14l1,1.09-2.07,2V22h1.5V20.74a.74.74,0,0,1,.5-.7A8.25,8.25,0,0,0,23.44,8.7Z",
  fill: "#33ba69"
});

var SvgLightLumenIcon = function SvgLightLumenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightLumenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light_lumen_icon.776ad604.svg";
export { ForwardRef as ReactComponent };